
let render = () => {
     require('./AppRenderer');
};
render();